/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Status_CancelledInputs */

const en_coaching_status_cancelled = /** @type {(inputs: Coaching_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const id_coaching_status_cancelled = /** @type {(inputs: Coaching_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibatalkan`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Coaching_Status_CancelledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_status_cancelled = /** @type {((inputs?: Coaching_Status_CancelledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Status_CancelledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_status_cancelled(inputs)
	return en_coaching_status_cancelled(inputs)
});